import React from 'react'

function CommonFooter() {
  return (
    <footer style={{lineHeight: '42px', backgroundColor: 'rgba(242,242,242)', textAlign: 'center', bottom: '0', width: '100%', marginTop:'20px'}}>
      <span style={{fontSize: '12px'}}>YOUR LOCAL FOOD PACKAGING MANUFACTURER  © 2020 NZ MADE 2013 Ltd. T/A </span>
      <a href="#" style={{fontFamily: 'avenir-lt-w01_35-light1475496,sans-serif', color: 'rgb(57,156,100)', fontSize: '12px'}}>Jadcup</a>
    </footer>
  )
}

export default CommonFooter
